<template>
  <div class="app-root" :style="styleProp">
    <router-view />
  </div>
</template>

<script>
// import { mapGetters } from 'vuex';
// import axios from "axios";

export default {
  name: 'App',

  components: {},
  data() {
    return {};
  },

  computed: {
    // ...mapGetters(['storage']),
    styleProp() {
      return {};
    },
  },

  created() {},

  mounted() {},

  methods: {},
};
</script>

<style lang="scss">
@import '~styles/fonts/didactgothic.scss';
@import '~styles/style.scss';
</style>

<style lang="scss" scoped>
.app-root {
  height: 100%;
  font-family: 'Didact Gothic';
}
</style>
